import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

import frameStorage from '../utils/storage/frame'
import memoryStorage from '../utils/storage/memory'

import createFrameStorage from './plugins/frameStorage'
import createPersistedState from 'vuex-persistedstate'

import {
  canWriteStorage,
  canWriteSessionStorage,
  w
} from '../utils/helpers'

Vue.use(Vuex)

const state = {
  connected: false,
  synced: false,
  focused: document.hasFocus(),
  timeOnPage: null,
  lastTimeUpdate: null,
  uid: null,
  session: null,
  visitor: null,
  messages: null,
  history: null,
  pageEventSid: null,
  pageEventKey: null,
  pageEventSubKey: null,
  historySid: null,
  historyKey: null,
  historySubKey: null,
  widget: null,
  defaultLang: { //add default lang settings here
    send: 'Send',
    powered_by: 'Powered by',
    enter_email_address: 'Enter Email Address',
    are_you_sure: 'Are you sure you want to end this chat?',
    today: 'Today',
    disable_sound: 'Disable Sound',
    enable_sound: 'Enable Sound',
    attach_file: 'Attach File',
    end_chat: 'End Chat',
    submit: 'Submit',
    cancel: 'Cancel',
    leave_comment: 'Leave a comment...',
    how_did_we_do: 'How did we do?',
    send_chat_transcript_to: 'Send chat transcript to',
    transcript_sent_to: 'Transcript sent to',
    error_sending_to: 'Error sending to',
    loading: 'Loading ...',
    please_wait: 'Please wait.',
    maxFileError: 'Maximum file size: 10MB',
    disallowedFile: 'File type not allowed',
    uploadFail: 'Upload failed',
    newMessage: '{count} new message',
    newMessages: '{count} new messages',
    typing: 'Typing...',
    sendAnother: 'Send another',
    email_transcript: 'Send transcript'
  },
  doScroll: false,
  minimize: true,
  teams: null,
  agents: null,
  integrations: null,
  tempHide: null,
  bootHidden: null,
  hidden: (w.dataset && w.dataset.hidden) ? w.dataset.hidden : false,
  cache: null,
  orgId: null,
  widgetId: null,
  roundrobin: null,
  files: [],
  previewImg: null,
  isPopout: w.mode == 'popout' ? true : false,
  isSafari: /safari/i.test(navigator.userAgent) && !/chrome/i.test(navigator.userAgent),
  reactionsDone: {}
}

//white list of state to save in frameStorage,
//will be overridden if storage is Cookie base
let paths = [
  'uid',
  'widget.onlineAgentsList',
  'widget.options',
  'widget.language',
  'widget.settings',
  'widget.reactions',
  'widget.theme',
  // 'agents',
  'session.view_state',
  'session.rate',
  'session.rated_at',
  'session.meta',
  'session.agent',
  'session.time_on',
  'session.reactions_done',
  'visitor.mute',
  'visitor.popout',
  'visitor.reactions_done',
  'visitor.session_id',
  'messages.data',
  'minimize',
  'cache'
]

// let sessionPaths = [
//   'session.view_state',
//   'session.rate',
//   'session.rated_at',
//   'session.meta',
//   'session.agent',
//   'session.time_on',
//   'session.reactions_done',
//   'visitor.mute',
//   'visitor.popout',
//   'visitor.reactions_done',
//   'visitor.session_id',
//   'messages.data',
//   'minimize',
// ]

const store = {
  state,
  mutations,
  getters,
  actions
}

//console.log(!(document.hidden || document.mozHidden || document.msHidden || document.webkitHidden))

if (w.mode == 'chat' || w.mode == 'popout') {

  //clear cache if new origin is different from referrer
  //console.log(document.referrer, location.origin, document.referrer.indexOf(location.origin))
  if (document.referrer &&
    location.origin &&
    document.referrer.indexOf(location.origin) < 0 &&
    canWriteStorage()
  ) {
    //console.log('cache removed')
    localStorage.removeItem('swaychat_cache_' + w.key)
  }

  // We put 5000 characters so that the initial storage checker would be 5 KB of size
  store.plugins = [
    // createPersistedState({
    //   key: 'swaychat_cache_' + w.key,
    //   storage: canWriteStorage('a'.repeat(1)) ? window.localStorage : memoryStorage,
    //   paths,
    //   filter: function(m) {
    //     return !(document.hidden || document.mozHidden || document.msHidden || document.webkitHidden)
    //   }
    // }),
    // createPersistedState({
    //   key: 'swaychat_cache_' + w.key,
    //   storage: canWriteSessionStorage('a'.repeat(1)) ? window.sessionStorage : memoryStorage,
    //   paths: sessionPaths
    // }),
    createFrameStorage(frameStorage, paths, function(m) {
      return !(document.hidden || document.mozHidden || document.msHidden || document.webkitHidden)
    }),
  ]

}

export default new Vuex.Store(store)
